(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-products-by-colors"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var carousel = document.querySelector('.tt-carousel-products-js');
    var container = document.querySelector('.colors-selector');
    var colorButtons = [].slice.call(document.querySelectorAll('.colors-selector .colored-circle-selector'));
    var presetHandle = container ? (container.getAttribute('data-default-color-handle') || '').trim() : '';
    var activeColorHandle = null;

    function getFirstButtonHandle() {
      return colorButtons.length ? colorButtons[0].getAttribute('data-handle') : '';
    }

    function setActiveButton(handle) {
      activeColorHandle = handle;
      colorButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-handle') === handle);
      });
    }

    function filterNow(handle) {
      var hasJQ = !!window.jQuery;
      var canSlick = hasJQ && jQuery.fn && jQuery.fn.slick && carousel;
      if (canSlick && jQuery(carousel).hasClass('slick-initialized')) {
        jQuery(carousel).slick('slickUnfilter');
        if (handle) jQuery(carousel).slick('slickFilter', '[data-color-handle="' + handle + '"]');
        jQuery(carousel).slick('setPosition');
      } else {
        var items = [].slice.call(document.querySelectorAll('.tt-carousel-products-js [data-color-handle]'));
        items.forEach(function (el) {
          var show = handle ? (el.getAttribute('data-color-handle') === handle) : true;
          el.style.display = show ? '' : 'none';
        });
      }
    }

    function applyInitial() {
      var initial = presetHandle || getFirstButtonHandle();
      if (!initial) { filterNow(null); return; }
      setActiveButton(initial);
      filterNow(initial);
    }

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = this.getAttribute('data-handle');
        if (!handle) return;
        setActiveButton(handle);
        filterNow(handle);
      });
    });

    if (window.jQuery && jQuery.fn && jQuery.fn.slick && carousel && !jQuery(carousel).hasClass('slick-initialized')) {
      jQuery(carousel).one('init', function () { applyInitial(); });
    }
    applyInitial();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
// Eventuali script JavaScript possono essere aggiunti qui

  } catch(e) { console.error(e); }
})();
})();
